import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { FeatureRolePermissionsProperty, getSecurityRoleByRoleName } from "@tKgpco/Services/SecurityRolesService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type Parameters = { roleName: string } & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, FeatureRolePermissionsProperty>;

export const BeginLoadRoleDetail: HandlerType = props => {
    props.dispatch({ type: "Custom/EditSecurityRoles/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getSecurityRoleByRoleName(props.parameter.roleName);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteLoadRoleDetail: HandlerType = props => {
    props.dispatch({
        type: "Custom/EditSecurityRoles/CompleteLoad",
        rolesDetail: props.apiResult,
    });
};

export const chain = [BeginLoadRoleDetail, RequestDataFromApi, CompleteLoadRoleDetail];

const loadRoleDetail = createHandlerChainRunner(chain, "loadRoleDetail");
export default loadRoleDetail;
